import React from 'react';
import { Button } from '@general';

import styles from './tabItem.module.scss';

interface TabItemProps {
	/**
	 * Name of this tab
	 */
	name: string;
	/**
	 * 	Boolean for determining whether the tab is selected
	 */
	selected: boolean;
	/**
	 * 	Function that handles onClick event of all tabs
	 */
	handleClick: (name: string) => void;
}

export const TabItem = ({ name, selected, handleClick }: TabItemProps) => {
	return (
		<Button
			customStyles={[styles.tab, selected && styles['tab-selected']].join(' ')}
			onClick={() => handleClick(name)}
			role="tab"
			type="default"
			ariaLabel={name}
		>
			{name}
		</Button>
	);
};
